module.exports = "https://assets.meiaentrada.org.br/static/media/controle-social.dd10f2ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/controle-social.png
// module id = 255
// module chunks = 0